import {mapState} from 'vuex';
import AdvCommonUtilMethods from '@advisor/util/AdvCommonUtilMethods';
import {COMPONENT_ID_PLATFORM_AREA_MAP} from '@advisor/util/constants';
import exceptionHandler from '@advisor/util/exceptionHandler';

export default {
  computed: {
    ...mapState({
      platformAccess: (state) => state.settings.default.platformAccess,
    }),
    componentId() {
      return this?.$route?.meta?.visibilityComponentId;
    },
    visibilityMxnDisabled() {
      return !this.isVisibleControl();
    },
    platformArea() {
      return this?.$route?.meta?.platformArea;
    },
  },
  methods: {
    /**
     * can use either the platformArea parameter passed in or the component var in the data (set in created)
     * @param platformArea
     * @param viewOnly: false for controls, default otherwise
     * @returns {boolean}
     */
    isVisible(platformArea = null, viewOnly = true) {
      if (!this.componentId && !this.platformArea && !platformArea) {
        const err = new Error('componentId and platformArea not set');

        exceptionHandler.handleGenericException('Visibility.isVisible', err);

        return false;
      }

      let pArea = platformArea ?? this.platformArea;

      if (!pArea) {
        pArea = COMPONENT_ID_PLATFORM_AREA_MAP[this.componentId];
      }

      return AdvCommonUtilMethods.isVisible(pArea, viewOnly);
    },
    /**
     * wrapper for controls
     * @param platformArea
     * @returns {boolean}
     */
    isVisibleControl(platformArea = null) {
      return this.isVisible(platformArea, false);
    },
  },
};
